"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_TYPES = void 0;
exports.ERROR_TYPES = {
    default: "GENERIC_FLIPSIDE_ERROR",
    sdk_error: "UNEXPECTED_SDK_ERROR",
    server_error: "SERVER_ERROR",
    query_run_rate_limit_error: "QUERY_RUN_RATE_LIMIT_ERROR",
    query_run_timeout_error: "QUERY_RUN_TIMEOUT_ERROR",
    query_run_execution_error: "QUERY_RUN_EXECUTION_ERROR",
    user_error: "USER_ERROR",
    api_error: "API_ERROR",
};
//# sourceMappingURL=error-types.js.map